export enum BackButtonDataHooks {
  BACK_BUTTON = 'back-button',
}
